export enum NuarxTag {
    NUARX_BRAND_TAG = '/vc/nuarx-brand',
    NUARX_KEY_TAG = '/vc/key/',
    NUARX_SITE_TAG = '/vc/nuarx-site',
    NUARX_ACCOUNT_TAG = '/vc/nuarx-account',
}
